import React, {Component} from 'react';
import config from './../../../config';
import AdTop from '../../AdTop';

class Banner extends Component {
    render() {
        let jDesktopOrder = this.props.jDesktopOrder;
        let sMobClass = this.props.jDesktopOrder ? '' : 'si-mob';
        if (!jDesktopOrder) {
            return <div className={"si-newads " + sMobClass}>
                {/* <img src={(config.playerImgBase + "homepage/PS4_banner@1x.png")} alt={""}/> */}
                {config.isMobile ? <AdTop /> : null}
            </div>
        }
        else {
            return (<div className={"si-card si-banner-card "}>
                <div className="si-sponsor">
                    {/* <img src={(config.playerImgBase + "homepage/mpu-banner.png")} alt={""}/> */}
                    {!config.isMobile ? <AdTop /> : null}
                </div>

            </div>)
        }
    }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/components/home/cards/Banner.js